import { render, staticRenderFns } from "./51zhjq.vue?vue&type=template&id=6ecb2e9a&"
import script from "./51zhjq.vue?vue&type=script&lang=js&"
export * from "./51zhjq.vue?vue&type=script&lang=js&"
import style0 from "./51zhjq.vue?vue&type=style&index=0&id=6ecb2e9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports